import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Montserrat', sans-serif;
    line-height: 1.219;
    overflow-x: hidden;
  }

  html {
    font-size: ${({theme}) => theme.fontSizes[3]};
  }

  body {
    background: linear-gradient(118.34deg, rgba(115, 144, 254, 0.2) 18.69%, rgba(115, 144, 254, 0) 56.36%), #F1F4FC;
    color: ${({theme}) => theme.colors.primary};

    img {
      height: auto;
    }

    a {
      color: ${({theme}) => theme.colors.primary};
      font-size: ${({theme}) => theme.fontSizes[2]};
      font-weight: 700;
      transition: color ${({theme}) => theme.transition};
      text-decoration: none;

      :hover {
        color: ${({theme}) => theme.colors.accent};
      }
    }
  }
`

export default GlobalStyle
